import api from 'api/axiosInstance';
import type { Bank, BankProviders } from 'types/banks.types';
import type { AvailableCountries } from 'types/users.types';

export type GetBanksParams = {
  page?: number;
  search?: string;
  dev?: boolean;
  country?: AvailableCountries;
  provider?: BankProviders;
};

const getBanks = (params?: GetBanksParams): Promise<Bank[]> =>
  api
    .get('/v2/connectors/financial-institutions', {
      params: {
        ...params,
      },
    })
    .then((res) => res.data);

export default getBanks;
